import { z } from 'zod';

export const stockStateEnum = z.enum([
  'available',
  'reserved',
  'damaged',
  'lost',
  'sold',
  'corrected',
  'recycled',
  'produced',
]);

export const stockMovementBaseSchema = z
  .object({
    store_id: z.string().min(1, 'Magasin requis'),
    product_id: z.string().nullable(),
    stock_state: stockStateEnum,
    quantity: z
      .number()
      .refine((value) => Number.isFinite(value), 'Quantité invalide'),
    manual: z.object({ description: z.string().optional() }).optional(),
    source_doc: z.record(z.unknown()).nullable().optional(),
  })
  .superRefine((values, ctx) => {
    const requiresPositive = values.stock_state !== 'corrected';
    if (requiresPositive && values.quantity < 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['quantity'],
        message: 'La quantité doit être positive',
      });
    }
  });

export const moveStockSchema = z.object({
  store_id_from: z.string().min(1),
  store_id_to: z.string().min(1),
  product_id: z.string().min(1),
  stock_state: stockStateEnum,
  quantity: z
    .number()
    .min(0, 'La quantité doit être positive')
    .refine((value) => Number.isFinite(value), 'Quantité invalide'),
  source_doc: z.record(z.unknown()).nullable().optional(),
});

export const replaceStockSchema = z.object({
  store_id: z.string().min(1),
  from_product_id: z.string().min(1),
  to_product_id: z.string().min(1),
  stock_state: stockStateEnum,
  quantity: z
    .number()
    .min(0, 'La quantité doit être positive')
    .refine((value) => Number.isFinite(value), 'Quantité invalide'),
  source_doc: z.record(z.unknown()).nullable().optional(),
});

export const reserveStockSchema = z.object({
  store_id: z.string().min(1),
  product_id: z.string().min(1),
  stock_state: stockStateEnum,
  quantity: z
    .number()
    .min(0, 'La quantité doit être positive')
    .refine((value) => Number.isFinite(value), 'Quantité invalide'),
  source_doc: z.record(z.unknown()).nullable().optional(),
});

export const writeOffStockSchema = z.object({
  store_id: z.string().min(1),
  product_id: z.string().min(1),
  quantity: z
    .number()
    .min(0, 'La quantité doit être positive')
    .refine((value) => Number.isFinite(value), 'Quantité invalide'),
  to_state: z.enum(['lost', 'damaged']),
  source_doc: z.record(z.unknown()).nullable().optional(),
});
